import { Badge } from '@/components/ui/badge';
import { MitarbeiterAvatar } from '@/domain/navigation/features/search/components/MitarbeiterAvatar';
import { MitarbeiterResult } from '@/domain/navigation/features/search/types/resultItem';
import { managerV1BaseUrl } from '@/utils';
import { faBan } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';

export default function MitarbeiterResultItem({
  mitarbeiterResult,
}: {
  mitarbeiterResult: MitarbeiterResult;
}) {
  return (
    <Link
      to={`${managerV1BaseUrl}/secure/v2/in/search.jsf?idMitarbeiter=${mitarbeiterResult.id}`}>
      <div
        data-show-second-badge="false"
        data-variante="Personal"
        className="w-72 px-2 py-3 inline-flex flex-col justify-center items-start">
        <div className="self-stretch inline-flex justify-start items-start gap-3">
          <MitarbeiterAvatar
            extern={mitarbeiterResult.extern}
            vorname={mitarbeiterResult.vorname}
            nachname={mitarbeiterResult.nachname}
            bildUrl={mitarbeiterResult.bildUrl}
          />
          <div className="flex-1 inline-flex flex-col justify-start items-start gap-0.5">
            <div className="self-stretch inline-flex justify-start items-center gap-1">
              <div className="flex-1 justify-start text-neutrals-900 text-sm font-normal truncate leading-tight max-w-48">
                {`${mitarbeiterResult.personalnummer} - ${mitarbeiterResult.vorname} ${mitarbeiterResult.nachname}`}
              </div>
              {mitarbeiterResult.type === 'INACTIVE' && (
                <Badge className="rounded-full size-5 flex justify-center bg-primary-orange-500 hover:bg-primary-orange-500">
                  <FontAwesomeIcon icon={faBan} />
                </Badge>
              )}
            </div>
            <div className="self-stretch flex flex-col justify-start items-start gap-2">
              <div className="self-stretch inline-flex justify-start items-center gap-1">
                <div className="flex-1 justify-start text-neutrals-700 text-xs font-normal  leading-none">
                  {mitarbeiterResult.standort}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
}
